export default __webpack_public_path__ + "static/midd-shield-091cfcf4f6c0c3396af969a178afe47a.svg";